import { DATE_FORMAT } from 'apps/constants'
import { CALENDAR, ONE_LINE } from 'assets/images'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import SelectDatePickerStyled from './styled'

interface SelectDatePickerProps {
  customClass?: string
  maxDate?: Date
  minDate?: Date
  startDate?: Date
  onChange?: (value: Date) => void
}

export default function SelectDatePicker({
  customClass,
  maxDate,
  minDate,
  startDate,
  onChange
}: SelectDatePickerProps) {
  const [selectedDate, setSelectedDate] = useState(startDate)
  const [isOpen, setIsOpen] = useState(false)
  const now = new Date()

  useEffect(() => {
    if (startDate) setSelectedDate(startDate)
  }, [startDate])

  const handleChange = (e: Date) => {
    setSelectedDate?.(e)
    onChange?.(e)
  }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    if (!selectedDate) {
      setSelectedDate(now)
    }
    setIsOpen(!isOpen)
  }

  const hanldeDateTimeClickOutside = () => {
    setIsOpen(false)
  }

  return (
    <SelectDatePickerStyled customClass={customClass}>
      <img src={ONE_LINE} alt='' className='orange-line position-absolute' />
      <span onClick={handleClick} className='cursor-pointer'>
        <img src={CALENDAR} alt='' className='calendar' />
        <span className='color-white time-calendar'>{selectedDate && startDate ? dayjs(selectedDate).format(DATE_FORMAT) : ""}</span>
      </span>
      {isOpen && (
        <DatePicker
          selected={selectedDate}
          onChange={handleChange}
          inline
          showTimeSelect
          // showTimeInput
          timeIntervals={1}
          timeFormat="HH:mm"
          dateFormat={"dd/MM/yyyy HH:mm"}
          minDate={minDate}
          maxDate={maxDate}
          minTime={
            selectedDate && dayjs(selectedDate).isSame(dayjs(), 'day')
              ? now
              : dayjs().hour(0).minute(0).toDate()
          }
          maxTime={dayjs().hour(23).minute(59).toDate()}
          // shouldCloseOnSelect={false}
          onClickOutside={hanldeDateTimeClickOutside}
        />
      )}
    </SelectDatePickerStyled>
  )
}
